module.exports = __webpack_public_path__ + "img/4.08b1b88d.jpg";